import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const FormulaIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* italic f */}
      <path d="M4 19V10.5C4 8.5 5 7 7 7" />
      <path d="M2 12h6" />
      {/* ( */}
      <path d="M11 6c-1.2 2-1.5 4-1.5 6s.3 4 1.5 6" />
      {/* x */}
      <path d="M14 9l3 6M17 9l-3 6" />
      {/* ) */}
      <path d="M20 6c1.2 2 1.5 4 1.5 6s-.3 4-1.5 6" />
    </svg>
  );
});

FormulaIcon.displayName = 'FormulaIcon';
